module.exports = __webpack_public_path__ + "static/img/torvalds.2d9b82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/torvalds.png
// module id = AhEW
// module chunks = 1